<template>
    <form class="login-form">
        <h1 class="h1 login-form__title">Заявка на регистрацию поставщика</h1>

        <div class="cabinet-form-group cabinet-form-group--login">
            <label class="cabinet-form-group__label" for="title"
                >Название компании</label
            >
            <input id="title" type="text" class="cabinet-form-group__input" />
        </div>

        <div class="cabinet-form-group cabinet-form-group--login">
            <label class="cabinet-form-group__label required" for="inn"
                >ИНН</label
            >
            <input
                id="inn"
                type="text"
                class="cabinet-form-group__input"
                required
            />
        </div>

        <div class="cabinet-form-group cabinet-form-group--login">
            <label class="cabinet-form-group__label" for="site">Сайт</label>
            <input id="site" type="text" class="cabinet-form-group__input" />
        </div>

        <div class="cabinet-form-group cabinet-form-group--login">
            <label class="cabinet-form-group__label" for="name">Имя</label>
            <input id="name" type="text" class="cabinet-form-group__input" />
        </div>

        <div class="cabinet-form-group cabinet-form-group--login">
            <label class="cabinet-form-group__label" for="phone">Телефон</label>
            <input id="phone" type="phone" class="cabinet-form-group__input" />
        </div>

        <div class="cabinet-form-group cabinet-form-group--login">
            <label class="cabinet-form-group__label required" for="email"
                >Электронная почта</label
            >
            <input
                id="email"
                type="email"
                class="cabinet-form-group__input"
                required
            />
        </div>

        <div class="login-form__agreement">
            <label class="cabinet-cart-checkbox">
                <input type="checkbox" />
                <span class="cabinet-cart-checkbox__checkmark"></span>
                Даю согласие на обработку персональных данных и принимаю
                <a href="javascript:void(0)" class="app-link app-link--blue"
                    >Пользовательское соглашение</a
                >
            </label>
        </div>

        <button
            type="button"
            class="cabinet-btn cabinet-btn--big cabinet-btn--w100"
        >
            Отправить заявку
        </button>

        <div class="login-form__info">
            После отправки заявки с вами свяжется представитель нашей компании
            для обсуждения деталей сотрудничества.
        </div>

        <div class="login-form__alredy-registered text-center">
            Уже зарегистрированы?
            <router-link to="/sign-in" class="app-link app-link--blue"
                >Войти</router-link
            >
        </div>

        <a href="javascript:void(0)" class="login-form__home-link"
            >Перейти на goldnet.ru</a
        >
    </form>
</template>

<script>
export default {
    name: 'SignUpSupplier'
}
</script>
